/** @jsxRuntime classic */
/** @jsx jsx */
import { useContext } from 'react';
import { css, jsx } from '@emotion/react';

import { useUserQuery } from '../../actions/UserActions';
import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';
import { useRateLimitsQuery } from '../../actions/WorkspaceActions';
import { UpgradeButton } from '../common/Buttons';
import Text from '@mui/material/Typography';
import AppContext from '../../contexts/app';

export default function LowPriorityMessage({
  noAction = false,
  dontCheckUploadLimit = false,
}) {
  const { user } = useUserQuery();
  const { t } = useTranslation();
  const { rateLimits } = useRateLimitsQuery({
    enabled: !!user?.role && user?.role !== 'guest',
  });
  const { setUploadDialog } = useContext(AppContext);

  const exceedsUploadLimit =
    user?.workspace?.type === 'trial' && rateLimits?.upload?.exceeded;

  if (user?.workspace?.type !== 'trial') {
    return null;
  }

  if (exceedsUploadLimit && !dontCheckUploadLimit) {
    const reset = (rateLimits?.upload?.reset / 60).toFixed(0);
    return (
      <div
        css={css`
          border-radius: 8px;
          background: #fff9eb;
          padding: 8px;
          display: flex;
          flex-direction: column;
          gap: 8px;
        `}
      >
        <Text variant="body1">
          {t(
            'Du har nått ditt tak på {{limit}} filer per timme. Du kan ladda upp fler filer om {{ minutes }} minuter',
            {
              limit: rateLimits?.upload?.limit,
              minutes: reset,
            }
          )}
        </Text>
        {user?.workspace?.type !== 'enterprise' && (
          <UpgradeButton
            text={t('Uppgradera för att kunna ladda upp mer')}
            event="rate_limit_upgrade"
          />
        )}
      </div>
    );
  }

  if (user?.high_priority) {
    return null;
  }

  return (
    <Alert
      severity="info"
      action={
        noAction ? null : (
          <UpgradeButton
            onClick={() => {
              setUploadDialog({ open: false });
            }}
            text={t('Uppgradera')}
            event="low_priority_upgrade"
          />
        )
      }
      css={css`
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
      `}
    >
      {t(
        'Visste du att betalande användare får snabbare leveranser? Uppgradera nu för snabbare leveranser och fler exporter'
      )}
    </Alert>
  );
}
